export default __webpack_public_path__ + "static/media/kalenday_banner.d2019fec.png";